import { render, staticRenderFns } from "./AmendmentFilingDetails.vue?vue&type=template&id=fd695530&scoped=true&"
import script from "./AmendmentFilingDetails.vue?vue&type=script&lang=js&"
export * from "./AmendmentFilingDetails.vue?vue&type=script&lang=js&"
import style0 from "./AmendmentFilingDetails.vue?vue&type=style&index=0&id=fd695530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd695530",
  null
  
)

export default component.exports